export const MIN_QTD_TO_SORT = 2

export const SEARCH_DEBOUNCE_TIME = 500
